import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";
import { canAccessDashboardUserManagement } from "@lib/permissions";

const SavedCompanyUserWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/CompanyUserManagement/SavedCompanyUserWrapper").then((module) => ({
    default: module.SavedCompanyUserWrapper,
  }))
);

export const savedCompanyUserNRO: NavigationRoutingObject = {
  Component: SavedCompanyUserWrapper,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("saved-company-user-nro-heading", "Edit Company User"),
  pageNameForTracking: () => "Edit Company User",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermissionForAnyScope, isFreeTrial }) => {
    // Please keep this in sync with the logic in the SettingsMenuItems component

    if (isFreeTrial) {
      return hasPermissionForAnyScope("viewFreeTrialDevelopers");
    }

    return canAccessDashboardUserManagement({ featureOn, hasPermissionForAnyScope });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/company_users/:appGroupId",
};
